import { createSlice, PayloadAction, Unsubscribe } from '@reduxjs/toolkit'
import { store } from '@atredux/store'
import { getSelectedLocale } from '@atredux/selectors/localeSelector'
import {
    Locale,
    localeExpanded,
    defaultLocaleByCountryCode,
} from '@amzn/jwo-store-management-platform-components'
import { resolveSessionLocale } from '@src/i18n/localeSession'

// Locale + localeExpanded now live in the shared platform-components library
// (utils/localeUtils). Re-exported here for existing platform callers that
// import them from the slice.
export { Locale, localeExpanded, defaultLocaleByCountryCode }

export interface ILocaleState {
    locale: Locale
}

export const initialState: ILocaleState = {
    // Resolves the `?locale=` param the native mobile shells pass in, falling
    // back to the stored preference then en-US. Unlike the previous exact-match
    // `Locale[param]` lookup, a regional variant such as es-MX now resolves to
    // its language (es-ES) instead of silently becoming undefined.
    locale: resolveSessionLocale(),
}

export const localeSlice = createSlice({
    name: 'locale',
    initialState,
    reducers: {
        setLocale: (state, action: PayloadAction<Locale>) => {
            state.locale = action.payload
        },
    },
})

export const subscribeToLocaleChange = (eventCallback: (locale: Locale) => void): Unsubscribe => {
    return store.subscribe(() => {
        eventCallback(getSelectedLocale(store.getState()))
    })
}

export const {
    setLocale,
} = localeSlice.actions

export default localeSlice.reducer
